import { IconButton } from '@digibee/beehive-ui';
import { Lock, ServerConnection, Settings } from 'iconoir-react';
import { FC } from 'react';

import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import i18n from '~/common/helpers/i18n';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';
import Role from '~/components/Role';
import Actions from '~/scenes/Others/scenes/App/components/Actions';

interface Props {
  goToDefaultLayout: () => void;
  goToSettings: () => void;
  goToAdmin: () => void;
  goToConnectivity: () => void;
}

const Links: FC<Props> = ({
  goToAdmin,
  goToSettings,
  goToConnectivity,
  ...props
}) => {
  const { CONNECTIVITY_ZTNA_MVP_ENABLED_FRONT } = featureFlagConstants;
  const { treatments } = useFeatureFlag([CONNECTIVITY_ZTNA_MVP_ENABLED_FRONT]);

  const showConnectivityButton =
    treatments[CONNECTIVITY_ZTNA_MVP_ENABLED_FRONT].treatment === 'on';

  return (
    <div className='flex items-center'>
      {showConnectivityButton ? (
        <Role name={['ZTNA:READ']}>
          <IconButton
            onClick={goToConnectivity}
            size='medium'
            title='Connectivity'
            data-testid='header-connectivity-button'
          >
            <ServerConnection />
          </IconButton>
        </Role>
      ) : null}
      <IconButton
        onClick={goToAdmin}
        size='medium'
        title={i18n.t('scenes.beta.labels.administration')}
        data-testid='header-administration-button'
      >
        <Lock />
      </IconButton>
      <IconButton
        onClick={goToSettings}
        size='medium'
        title={i18n.t('scenes.beta.labels.setting_plural')}
        data-testid='header-settings-button'
      >
        <Settings />
      </IconButton>
      <Actions {...props} />
    </div>
  );
};

export default Links;
